import { SearchRoundedIcon, TextField } from '@shared/components';
import debounce from 'lodash/debounce';

export interface RoleUserAdditionListSearchInputProps {
  debounceTime?: number;
  onChange?: (value: string) => void;
}

export default function RoleUserAdditionListSearchInput(
  props: Readonly<RoleUserAdditionListSearchInputProps>,
) {
  const { onChange, debounceTime = 700 } = props;

  const handleSearch = debounce((value: string) => {
    onChange?.(value);
  }, debounceTime);

  return (
    <TextField
      placeholder='ค้นหาผู้ใช้...'
      onChange={(event) => {
        handleSearch(event.target.value);
      }}
      slotProps={{
        input: {
          startAdornment: (
            <SearchRoundedIcon
              sx={{ fontSize: '24px', color: (theme) => theme.palette.grey[500] }}
            />
          ),
        },
      }}
    />
  );
}
